import React from 'react'

export default function Resume() {
  return (
    <div>Resume</div>
  )
}
